import React from 'react';
import ReactDOM from 'react-dom';

import ReservationSimple from './ReservationSeule';
import ReservationMultiples from './ReservationMultiples';
document.querySelectorAll(".reservationSimpleApp").forEach(i=>{
    let data = window.reservData[i.dataset.reserv];
    data.plateaux = data.plateaux.map(i => +i)
    ReactDOM.render(<ReservationSimple constants={data} />, i);
})
document.querySelectorAll(".reservationMultipleApp").forEach(i=>{
    let data = window.reservData[i.dataset.reserv];
    data.plateaux = data.plateaux.map(i => +i)
    ReactDOM.render(<ReservationMultiples constants={data} />, i);
})
window.jQuery(function(){
  window.jQuery.datepicker.regional['fr'] = {
   closeText: 'Fermer',
   prevText: '&#x3c;Préc',
   nextText: 'Suiv&#x3e;',
   currentText: 'Aujourd\'hui',
   monthNames: ['Janvier','Fevrier','Mars','Avril','Mai','Juin',
   'Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
   monthNamesShort: ['Jan.','Fev.','Mar.','Avr.','Mai','Jun.',
   'Jul.','Août','Sep.','Oct.','Nov.','Déc.'],
   dayNames: ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
   dayNamesShort: ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'],
   dayNamesMin: ['D','L','M','M','J','V','S'],
   weekHeader: 'Sm',
   dateFormat: 'dd-mm-yy'
   };
  window.jQuery.datepicker.setDefaults(window.jQuery.datepicker.regional['fr']);
});



// WEBPACK FOOTER //
// ./src/index.js